import React, { useState } from 'react';
import ApiDataService from '../../services/ApiDataService';

const FolderNode = ({ path, label, currentPath, onNavigate }) => {
  const [expanded, setExpanded] = useState(false);
  const [children, setChildren] = useState(null);
  const [loading, setLoading] = useState(false);

  const toggle = () => {
    const next = !expanded;
    setExpanded(next);
    if (next && children === null) {
      setLoading(true);
      ApiDataService.getAll('admin/portal/file-manager/list', `?path=${encodeURIComponent(path)}`).then(response => {
        setLoading(false);
        if (response.data.return_status === "0") {
          setChildren((response.data.result.entries || []).filter(e => e.type === 'folder'));
        } else {
          setChildren([]);
        }
      }).catch(() => {
        setLoading(false);
        setChildren([]);
      });
    }
  };

  const isActive = currentPath === path;

  return (
    <div style={{ paddingLeft: 12 }}>
      <div
        style={{ cursor: 'pointer', fontWeight: isActive ? 'bold' : 'normal' }}
        onClick={() => { toggle(); onNavigate(path); }}
      >
        {expanded ? '▾' : '▸'} {label}
      </div>
      {expanded && (
        <div>
          {loading && <div style={{ paddingLeft: 16 }}>Loading...</div>}
          {children && children.map(child => (
            <FolderNode
              key={child.name}
              path={path ? `${path}/${child.name}` : child.name}
              label={child.name}
              currentPath={currentPath}
              onNavigate={onNavigate}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const FolderTree = ({ currentPath, onNavigate }) => {
  const [rootChildren, setRootChildren] = useState(null);

  React.useEffect(() => {
    ApiDataService.getAll('admin/portal/file-manager/list', '?path=').then(response => {
      if (response.data.return_status === "0") {
        setRootChildren((response.data.result.entries || []).filter(e => e.type === 'folder'));
      } else {
        setRootChildren([]);
      }
    }).catch(() => setRootChildren([]));
  }, []);

  return (
    <div style={{ minWidth: 220, borderRight: '1px solid #dee2e6', paddingRight: 8 }}>
      <div
        style={{ cursor: 'pointer', fontWeight: currentPath === '' ? 'bold' : 'normal' }}
        onClick={() => onNavigate('')}
      >
        uploads
      </div>
      {rootChildren === null && <div style={{ paddingLeft: 12 }}>Loading...</div>}
      {rootChildren && rootChildren.map(child => (
        <FolderNode
          key={child.name}
          path={child.name}
          label={child.name}
          currentPath={currentPath}
          onNavigate={onNavigate}
        />
      ))}
    </div>
  );
};

export default FolderTree;
